import React, { useState, useEffect, useContext } from 'react';
import Icon from '../../common/Icon';
import SorterIcon from './SorterIcon';
import { isTextType } from '../../fields/constants/subtypes';
import { OptionFilterDropdown } from './FilterEditor';
import { QueryContext } from '../../../hooks/Contexts';

const ColumnFilterField = ({
  field,
  handleFilter,
  handleSort,
  removeFilter,
}) => {
  const { queryParams } = useContext(QueryContext);
  const [filtering, setFiltering] = useState(
    Object.keys(queryParams.filters).includes(field.id.toString())
  );
  const [selecting, setSelecting] = useState(false);
  const [showSearchTip, setShowSearchTip] = useState(false);
  const [textValue, setTextValue] = useState(
    queryParams.filters[field.id] || ''
  );
  const titleClass = (filtering ? '' : 'un') + 'filtered-field-title';

  useEffect(() => {
    if (Object.keys(queryParams.filters).length === 0) {
      setFiltering(false);
      setSelecting(false);
      setTextValue('');
    }
  }, [queryParams.filters]);

  const handleTextFilterChange = (e) => {
    setShowSearchTip(
      document.activeElement === e.target && e.target.value.length > 0
    );
    setTextValue(e.target.value);
  };

  const handleTextFilterBlur = (e) => {
    if (!textValue) {
      if (Object.keys(queryParams.filters).includes(field.id.toString())) {
        removeFilter(field.id);
      }
      setFiltering(false);
    }
  };

  const handleTextFilterEnter = (e) => {
    if (e.key != 'Enter') return;
    if (filtering) {
      if (textValue) {
        handleFilter(field.id, textValue);
      } else {
        removeFilter(field.id);
        setFiltering(false);
      }
    }
    setShowSearchTip(false);
  };

  const handleTextFilterClear = (e) => {
    setShowSearchTip(false);
    setFiltering(false);
    if (textValue) {
      setTextValue('');
      if (Object.keys(queryParams.filters).includes(field.id.toString())) {
        removeFilter(field.id);
      }
    }
  };

  return (
    <th className='filterable-sub-title'>
      {isTextType(field.type) ? (
        filtering ? (
          <div className='column-filter expanded'>
            {showSearchTip && (
              <div className='filter-tip'>
                Press <b>ENTER</b> to Search
              </div>
            )}
            <span className={titleClass} title={field.name}>
              {field.name}
            </span>
            <input
              type='text'
              id={'filter-for-' + field.id}
              onChange={(e) => handleTextFilterChange(e)}
              onBlur={(e) => handleTextFilterBlur(e)}
              onKeyDown={(e) => handleTextFilterEnter(e)}
              value={textValue}
              autoFocus
            />
            <Icon
              icon='times-circle'
              onClick={(e) => handleTextFilterClear(e)}
            />
          </div>
        ) : (
          <div className='column-filter'>
            <span className={titleClass} title={field.name}>
              {field.name}
            </span>
            <Icon
              icon='search fa-rotate-90'
              onClick={() => setFiltering(!filtering)}
            />
          </div>
        )
      ) : (
        <div className={'column-option-filter' + (filtering ? ' active' : '')}>
          <span className={titleClass} title={field.name}>
            {field.name}
          </span>
          <Icon
            icon='search fa-rotate-90'
            onClick={() => setSelecting(!selecting)}
          />
          {selecting && (
            <OptionFilterDropdown
              field={field}
              handleFilter={handleFilter}
              filtering={filtering}
              setFiltering={setFiltering}
              removeFilter={removeFilter}
              setSelecting={setSelecting}
              selecting={selecting}
            />
          )}
        </div>
      )}
      <SorterIcon id={field.id.toString()} handleSort={handleSort} />
    </th>
  );
};

export default ColumnFilterField;
